<template>
  <div class="addClient-container">
    <!-- 导航栏 -->
    <van-nav-bar
      class="page-nav-bar"
      title="新建客户"
      left-arrow
      @click-left="$router.back()"
    ></van-nav-bar>
    <!-- /导航栏 -->
    <!-- Field 是基于 Cell 实现的，可以使用 CellGroup 作为容器来提供外边框。 -->
    <van-cell-group>
      <van-field v-model="value" placeholder="请输入客户名称" />
    </van-cell-group>
    <!-- 基本信息 -->
    <van-row class="title-text">基本信息</van-row>
    <van-cell
      title="状态"
      is-link
      @click="showPopup"
      value="意向(C)"
    ></van-cell>
    <van-cell title="行业" is-link @click="showPopup" value="销售"></van-cell>
    <van-cell title="类型" is-link @click="showPopup" value="客户"></van-cell>
    <!-- 弹出层 -->
    <van-popup
      v-model="show"
      closeable
      position="bottom"
      :style="{ height: '30%' }"
      >内容</van-popup
    >
    <!--  联系信息-->
    <van-row class="title-text">联系信息</van-row>
    <van-cell-group>
      <van-field v-model="value" label="电话" placeholder="请输入电话" />
      <!-- 选择地区 -->
      <van-field
        v-model="fieldValue"
        is-link
        readonly
        label="地区"
        placeholder="请选择所在地区"
        @click="areaShow = true"
      />
      <van-popup v-model="areaShow" round position="bottom">
        <van-cascader
          v-model="cascaderValue"
          title="请选择所在地区"
          :options="options"
          @close="areaShow = false"
          @finish="onFinish"
        />
      </van-popup>
      <!-- /选择地区 -->
      <van-field v-model="value" label="地址" placeholder="请输入地址" />
    </van-cell-group>

    <!--  其它信息-->
    <van-row class="title-text">其它信息</van-row>
    <van-field
      v-model="message"
      rows="2"
      autosize
      label="备注"
      type="textarea"
      placeholder="请输入留言"
    />
    <van-row class="title-text">联系人信息</van-row>
    <!--  联系人信息-->
    <van-cell-group>
      <van-field v-model="value" label="名称" placeholder="点击填写" />
      <van-field v-model="value" label="头衔" placeholder="点击填写" />
      <van-field v-model="value" label="称呼" placeholder="点击填写" />
    </van-cell-group>
  </div>
</template>

<script>

export default {
  name: 'AddClientIndex',
  components: {

  },
  props: {},
  data() {
    return {
      show: false,
      areaShow: false,
      // v-model="value" 没有定义在实例上会报错
      value: '',
      fieldValue: '',
      cascaderValue: '',
      message: '',
      // 选项列表，children 代表子选项，支持多级嵌套
      options: [
        {
          text: '浙江省',
          value: '330000',
          children: [{ text: '杭州市', value: '330100' }],
        },
        {
          text: '江苏省',
          value: '320000',
          children: [{ text: '南京市', value: '320100' }],
        },
      ],
    }
  },
  computed: {},
  watch: {},
  created() { },
  mounted() { },
  methods: {
    showPopup() {
      this.show = true;
    },
    // 全部选项选择完毕后，会触发 finish 事件
    onFinish({ selectedOptions }) {
      this.areaShow = false;
      this.fieldValue = selectedOptions.map((option) => option.text).join('/');
    }
  }
}
</script>

<style scoped lang='less'>
/deep/.title-text {
  font-size: 30px;
  margin: 5px 0 10px 10px;
  color: #b5b5b5;
}
</style>